var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@lucidlink/uicore';
import { useDependency } from '#context';
export const FilespaceFooterLayout = ({ children }) => {
    _react_refresh_temp_2();
    // eslint-disable-next-line @typescript-eslint/naming-convention -- This is needed since FilespaceFooter is a React component
    const FilespaceFooter = useDependency('FilespaceFooter');
    return (_jsxs(Box, { grow: 1, kind: "level2", orientation: "vertical", radius: "m", shrink: 1, children: [_jsx(Box, { grow: 1, orientation: "vertical", scrollableY: true, shrink: 1, children: children }), _jsx(FilespaceFooter, {})] }));
};
_react_refresh_temp_1 = FilespaceFooterLayout;
$RefreshReg$(_react_refresh_temp_1, "FilespaceFooterLayout");
_react_refresh_temp_2(FilespaceFooterLayout, "Ct0PkSk2oGeHFvA66vOAd8EU0Vw=", false, () => [useDependency]);
